import DataTable from 'components/ui/DataTable/data-table';
import React, { FC, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useRoutineWiseModuleFeedbackQuery } from 'redux/reducers/Feedback/sessionAndModuleFeedback';
import { BiLastPage } from 'react-icons/bi';
import ViewIcon from '../../../../assets/images/icons/view.png';

interface IRoutineManagementTable {
  tableHeaders?: () => React.ReactNode;
  status: number;
  isSuperAdmin: boolean

}

const RoutineFeedBackSession: FC<IRoutineManagementTable> = ({ tableHeaders, status, isSuperAdmin }) => {
  const navigate = useNavigate();
  const { routineId } = useParams<{ routineId: string }>();

  const [pageNo, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const { data: sessionFeedBack, isLoading: isLoadingFeedbackSession } =
    useRoutineWiseModuleFeedbackQuery({ pageNo, pageSize, routineId });
  const totalRows = sessionFeedBack?.data && sessionFeedBack?.data.length > 0 ? sessionFeedBack?.data?.[0].row_total : 0;

  const totalPages = Math.ceil(totalRows / 10);
  const canNext = pageNo < totalPages;
  const canPrevious = pageNo > 1;
  const columns = [
    {
      Header: 'Module Name',
      Cell: (data: any) => {
        return <>{`Module ${data.row.index + 1} : ${data.row.original.title}`}</>;
      }
    },
    {
      Header: 'Action',
      Cell: (data: any) => {
        return (
          <>
            <img
              src={ViewIcon}
              onClick={() => {
                navigate(
                  `/routine-management/${routineId}/feedback/module/${data.row.original.course_id}/view`,
                  {
                    state: {
                      topic: `Module ${data.row.index + 1}: ${data.row.original.title}`
                    }
                  }
                );
              }}
            />
            {isSuperAdmin && <BiLastPage
              style={{ marginLeft: 10 }}
              onClick={() =>
                navigate(
                  `/training/routine/${routineId}/module/${data.row.original.course_id}/feedback`
                )
              }
            />}
          </>
        );
      }
    }
  ];
  return (
    <>
      <div>
        <DataTable
          columns={columns}
          isLoading={isLoadingFeedbackSession}
          data={sessionFeedBack?.data || []}
          tableHeaders={tableHeaders}
          pagination={{
            canNext,
            canPrevious,
            prevPage: () => {
              if (canPrevious) {
                setPage((prev) => prev - 1);

              }
            },
            nextPage: () => {
              if (canNext) {
                setPage((prev) => prev + 1);
              }
            }
          }}
        />
      </div>
    </>
  );
};

export default RoutineFeedBackSession;
